// react component
import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';

import estatePlanningImg from '../../assets/life-doc-icons/ICONS_ESTATE-PLANNING.svg';
import funeralArrangementsImg from '../../assets/life-doc-icons/ICONS_FINAL-ARRANGEMENTS.svg';
import financialDocumentsImg from '../../assets/life-doc-icons/ICONS_FINANCIAL-DOCUMENTS.svg';
import healthcareDirectiveImg from '../../assets/life-doc-icons/ICONS_HEALTH-CARE-DIRECTIVE.svg';
import homeAndFamilyDocumentsImg from '../../assets/life-doc-icons/ICONS_HOME-AND-FAMILY-DOCUMENTS.svg';
import letterToSurvivorsImg from '../../assets/life-doc-icons/ICONS_LETTER-TO-SURVIVORS.svg';
import livingTrustImg from '../../assets/life-doc-icons/ICONS_LIVING-TRUST.svg';
import otherBequestsImg from '../../assets/life-doc-icons/ICONS_OTHER-BEQUESTS.svg';
import powerOfAttorneyImg from '../../assets/life-doc-icons/ICONS_POWER-OF-ATTORNEY.svg';
import transferOnDeathDeedImg from '../../assets/life-doc-icons/ICONS_TRANSFER-ON-DEATH-DEED.svg';
import willImg from '../../assets/life-doc-icons/ICONS_WILL-AND-TESTAMENT.svg';
import { PortfolioOption, ScreenHeader } from '../components';
import {
  IdentityContext, PersonIdentityProvider, UserIdentityProvider
} from '../context';



export const options = [
  {
    option: 'Will',
    icon: 'description',
    imgPath: willImg
  },
  {
    // prioritize
    option: 'Other Bequests',
    icon: 'redeem',
    imgPath: otherBequestsImg
  },
  {
    // prioritize
    option: 'Healthcare Directive',
    icon: 'ecg_heart',
    imgPath: healthcareDirectiveImg
  },
  {
    // prioritize
    option: 'Funeral Arrangements',
    icon: 'calendar_today',
    imgPath: funeralArrangementsImg
  },
  {
    option: 'Power of Attorney',
    icon: 'shield',
    imgPath: powerOfAttorneyImg
  },
  {
    // prioritize
    option: 'Letter to Survivors',
    icon: 'mail',
    imgPath: letterToSurvivorsImg
  },
  {
    option: 'Living Trust',
    icon: 'redeem',
    imgPath: livingTrustImg
  },
  {
    // prioritize
    option: 'Transfer on Death Deed',
    icon: 'house',
    imgPath: transferOnDeathDeedImg
  },
  {
    option: 'Estate Planning',
    icon: 'assignment',
    imgPath: estatePlanningImg
  },
  {
    option: 'Financial Documents',
    icon: 'account_balance',
    imgPath: financialDocumentsImg
  },
  {
    option: 'Home and Family Documents',
    icon: 'group',
    imgPath: homeAndFamilyDocumentsImg
  }
];

export function LifeDocumentsPage() {
  const { personId } = useParams<{ personId: string }>();
  const self = personId === 'self';

  if (!self) {
    return (
      <PersonIdentityProvider>
        <LifeDocumentsComponent />
      </PersonIdentityProvider>
    );
  }

  return (
    <UserIdentityProvider>
      <LifeDocumentsComponent />
    </UserIdentityProvider>
  );
}

export function LifeDocumentsComponent() {
  const person = useContext(IdentityContext);

  const { personId } = useParams<{ personId: string }>();

  const self = personId === 'self';
  const name = `${person.firstName} ${person.lastName}`;

  const header = self ? 'My Life Documents' : `Life Documents for ${name}`;
  const linkText = self ? 'Life documents for others' : 'View or create life documents for myself';
  const linkTo = self ? '/people' : '/people/self';

  return (
    <div className="life-documents-page portfolio-page">
      <ScreenHeader
        title={header}
        description="View or create a will, health care directive, final arrangements and other documents."
      />
      <Link to={linkTo}>
        <button style={{ marginTop: '16px' }}>
          {linkText}
        </button>
      </Link>
      <div className="portfolio-options">
        {options.map(({ option, icon = '', imgPath = '' }) => (
          <PortfolioOption key={option} option={option} icon={icon} bgImg={imgPath} />
        ))}
      </div>
    </div>
  );
}
